import React, { FC, useMemo, useRef } from 'react'
import { IColumn } from 'typescript/interfaces/tableUi'
import TableComponent, { TableComponentType } from 'UI/Table'
import { useTableComponentStyle } from 'UI/Table/style'
import { IExternalDeal } from 'typescript/interfaces/deals'
import { convertToPriceFormat } from 'utils/formatters'
import { TableCell, TableFooter, TableRow } from '@material-ui/core'
import { useTableFooter } from 'components/Dashboard/style'
import classNames from 'classnames'

const TableExternalDealsLight = TableComponent as TableComponentType<IExternalDeal>

interface IExternalDealsLightTableProps {
  data: IExternalDeal[]
}

const ExternalDealsLightTable: FC<IExternalDealsLightTableProps> = ({ data }) => {
  const classes = useTableComponentStyle()
  const columnsRef = useRef<IColumn<IExternalDeal>[]>([
    {
      label: 'Funder',
      field: 'funder',
      bodyCellClassName: classes.accentCell,
      render: (rowData) => rowData.funder,
    },
    {
      label: 'Payoff Balance',
      field: 'payoffBalance',
      bodyCellClassName: classes.accentCell,
      render: (rowData) => convertToPriceFormat(rowData.payoffBalance),
    },
  ])

  return (
    <TableExternalDealsLight
      columns={columnsRef.current}
      data={data}
      Footer={() => <FooterExternalDeals data={data} />}
    />
  )
}

const FooterExternalDeals: FC<{ data: IExternalDeal[] }> = ({ data }) => {
  const classes = useTableFooter()
  const totalPayoff = useMemo(
    () => data.reduce((sum, ed) => sum + (Number(ed.payoffBalance) || 0), 0),
    [data],
  )

  return (
    <TableFooter>
      <TableRow>
        <TableCell className={classNames(classes.cellStyle, classes.footerTableCell, classes.narrow)}>
          Total Payoff Balance
        </TableCell>
        <TableCell className={classNames(classes.cellStyle, classes.footerTableCell, classes.narrow)}>
          {convertToPriceFormat(totalPayoff)}
        </TableCell>
      </TableRow>
    </TableFooter>
  )
}

export default ExternalDealsLightTable
